import React, { Suspense, lazy } from 'react';
import { canUseDOM } from '../../utils';
export const IDENTIFY_TRAVELERS_CLOSE_EXPIRED = "identify-travelers-close-expired";
const IdentifyTravelersLazyLoadedContent = /*#__PURE__*/lazy(() => import("./IdentifyTravelersLazyLoadedContent"));
const SuspenseWrapper = props => {
  return /*#__PURE__*/React.createElement(Suspense, {
    fallback: /*#__PURE__*/React.createElement(React.Fragment, null)
  }, /*#__PURE__*/React.createElement(IdentifyTravelersLazyLoadedContent, props));
};
const IdentifyTravelers = props => {
  if (canUseDOM && Number(localStorage.getItem(IDENTIFY_TRAVELERS_CLOSE_EXPIRED)) < Date.now()) {
    return /*#__PURE__*/React.createElement(SuspenseWrapper, props);
  } else {
    return /*#__PURE__*/React.createElement(React.Fragment, null);
  }
};
export default IdentifyTravelers;